<template>
  <div>
    <div class="top">
      <div class="header">
        <div @click="back" class="title">
          <i class="el-icon-arrow-left" style="margin-right: 10px;font-weight: bolder">返回</i>{{ title }}
        </div>
      </div>
      <div>直播回放</div>
    </div>
    <div style="width: 90%;margin: auto">
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
      ></video-player>
      <!--      <video width="100%" height="100%" controls preload controlslist="nodownload" @contextmenu="contextmenu"-->
      <!--             :src="liveSrc" :poster="picture"></video>-->
    </div>
  </div>
</template>

<script>

import {videoPlayer} from "vue-video-player";
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

export default {
  components: {videoPlayer},
  props: {},
  data() {
    return {
      liveSrc: this.$route.query.src,
      picture: this.$route.query.picture,
      title: this.$route.query.title,
      // 视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 3.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",
          src: this.$route.query.src//url地址
        }],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,//当前时间和持续时间的分隔符
          durationDisplay: true,//显示持续时间
          remainingTimeDisplay: true,//是否显示剩余时间功能
          fullscreenToggle: true  //全屏按钮
        }
      }
    }
  },
  mounted() {
  },

  methods: {
    back() {
      this.$router.go(-1)
    },
    contextmenu(e) {
      e.returnValue = false
    }
  }

}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #282828;
  color: white;

  .iconfont {
    transform: rotate(-180rgd);
  }

  .header {
    background-color: #282828;
    padding: 15px 0 15px 50px;
    margin-right: 20px;
    font-size: 14px;
    color: white;

    .title {
      cursor: pointer;
    }
  }

  > div:nth-child(2) {
    background-color: #f28312;
    border-radius: 5px;
    font-size: 10px;
    padding: 4px;
    color: white;
  }
}


.player-container {
  background-color: black;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;

  //.playerLook {
  //  width: 100%;
  //  height: 100%;
  //}

}

.video-player {
  width: 100%;
  height: auto;
  margin: 0 auto;

}

</style>
